import { useState, useEffect } from 'react';
import api from '../utils/api';

export default function useManagementDashboard(batchId = 1) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await api.analyticsDashboardManagement({ batchId });
        setData(res);
      } catch (err) {
        console.error('analyticsDashboardManagement error:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (batchId) {
      fetchData();
    }
  }, [batchId]);

  return { data, loading, error };
}
